import { Card, CardContent } from '@/components/ui/card';
import { TierBadge } from './TierBadge';

interface ResultsSummaryProps {
  summary: string;
  tier: 1 | 2 | 3;
}

/**
 * Renders a summary string with inline [N] citation markers highlighted as copper badges.
 */
function renderWithCitations(text: string) {
  const parts = text.split(/(\[\d+\])/g);
  return parts.map((part, i) => {
    if (/^\[\d+\]$/.test(part)) {
      return (
        <span
          key={i}
          className="mx-0.5 inline-flex items-center rounded bg-copper/10 px-1 py-0.5 text-xs font-semibold text-copper"
        >
          {part}
        </span>
      );
    }
    return <span key={i}>{part}</span>;
  });
}

export function ResultsSummary({ summary, tier }: ResultsSummaryProps) {
  // Split summary into paragraphs
  const paragraphs = summary
    .split('\n')
    .filter((p) => p.trim().length > 0);

  return (
    <Card className="border-gray-200">
      <CardContent>
        <div className="mb-4 flex items-center gap-3">
          <TierBadge tier={tier} />
          <span className="text-xs text-gray-400">Research-Based Analysis</span>
        </div>
        <div className="space-y-3">
          {paragraphs.map((paragraph, i) => (
            <p
              key={i}
              className="text-sm leading-relaxed text-gray-700"
            >
              {renderWithCitations(paragraph)}
            </p>
          ))}
        </div>
        <div className="mt-6 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
          <p className="text-xs leading-relaxed text-gray-400">
            <span className="font-semibold text-gray-500">Disclaimer:</span>{' '}
            This analysis is for educational purposes only and does not
            constitute medical advice. Always consult a qualified healthcare
            provider before making changes to your health regimen.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
